<template>
	<div id="app">
		<el-dialog title="提示" :visible.sync="visibleerrorinfoDialog" width="400px" :center="true" :close-on-click-modal="false"
		 @close="closeDialog">
			<div style="width:100%;display:flex">
				<label style="text-align:center;font-size:14px;width:100%;">{{this.messageerrorinfo}}</label>
			</div>
		</el-dialog>
		<router-view>
			<!-- 这里是不被缓存的视图组件，比如 page3 -->
		</router-view>
		<!-- <main-view></main-view> -->
		<!-- <person-info></person-info> -->
	</div>
</template>
<script>
	import eventBus from "@/js/utils/eventBus";
	import config from "@/js/utils/config";
	import axios from 'axios-https-proxy-fix'
	export default {
		name: "App",
		data() {
			return {
				messageerrorinfo: "",
				haveshowerrorinfo: false,
				visibleerrorinfoDialog: false
			};
		},
		// 监听路由变化
		// 路由变化后，关闭掉错误信息弹窗
		watch: {
			'$route': 'closeDialog'
		},
		created() {
			let userinfo = JSON.parse(localStorage.getItem("userinfo"));
			if (userinfo) {
				this.getFilters();
			}
			eventBus.$on("showerrorinfo", result => {
				if (!this.haveshowerrorinfo) {
					let message = result.response.data.text;
					if (message) {
						this.messageerrorinfo = message;
						this.haveshowerrorinfo = true;
						this.visibleerrorinfoDialog = true;
					}
				}
			});
			let hash = window.location.hash;
			let querystr = hash.split("?")[1];
			let path = hash.split("?")[0];
			path = path.substring(1, path.length);
			let queryObject = {};
			if (querystr) {
				let newqueryStr = String(querystr).slice(0, this.querystr);
				let querys = newqueryStr.split("&");
				querys.forEach(element => {
					let keys = element.split("=");
					if (keys[0] == "real_name") {
						queryObject[keys[0]] = decodeURI(keys[1]);
					} else {
						queryObject[keys[0]] = keys[1];
					}
				});
				let userName = queryObject["user_name"];
				let role = queryObject["role"];
				let user_id = queryObject["user_id"];
				if (userName && role && user_id) {
					//设置导航栏用户名
					let userInfo = {
						userName: userName,
						role: role,
						userId: user_id
					};
					localStorage.setItem("userinfo", JSON.stringify(userInfo));
					this.getFilters();
					localStorage.removeItem("createProject_ProjectId");
					localStorage.removeItem("createProject_OperationType");
					localStorage.removeItem("projectDetailId");
					localStorage.removeItem("createConfigScene");
					//清空本地所有缓存的数据
				}
			}
			this.$router.push({
				path: path,
				query: queryObject
			});
		},
		methods: {
			getFilters() {
				// this.HttpUtils.get(config.api.voice_conversions, {})
				// 	.then(result => {
				// 		let translate = result.data;
				// 		let filterObject = {
				// 			translate: translate,
				// 		};
				// 		localStorage.setItem("filterObject", JSON.stringify(filterObject));
				// 	})
				// 	.catch(execption => {
				// 		console.log(execption);
				// 	});
			},
			closeDialog() {
				this.messageerrorinfo = "";
				this.haveshowerrorinfo = false;
				this.visibleerrorinfoDialog = false;
			},
			getUrlStr(name, search) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = search.substr(1).match(reg);
				if (r != null) return r[2];
				return null;
			}
		}
	};

</script>

<style>
	body {
		margin: 0px;
		padding: 0px;
		height: 100%;
	}

	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		height: 100%;
	}
	/* 避免所有的遮罩层，将滚动栏裁剪 */
	.el-loading-parent--hidden{
    	overflow:auto!important;
	}
	.el-popup-parent--hidden{
		overflow:auto!important;
	}

</style>



// WEBPACK FOOTER //
// src/js/App.vue